import * as React from "react"
import { Heading, Text } from "gatsby-interface"
import { StandardSingleColumn } from "@modules/ui/layouts/Containers"
import { useOrganizationNameFieldsFragment } from "@modules/organization/Settings/fragments.generated"
import { useOrganizationBaseDetailsQuery } from "@modules/organization/queries.generated"
import { FormattedMessage } from "@modules/locales"
import { createSite as text } from "@modules/locales/default"
import { headingCss } from "../../shared/components/SiteCreationWizardHeader"

export type SiteCreationWizardHeaderProps = {
  organizationId: string
  subHeadingText?: string
}

export function SiteCreationWizardHeader({
  organizationId,
  subHeadingText,
}: SiteCreationWizardHeaderProps) {
  const { data: cacheData } = useOrganizationNameFieldsFragment(organizationId)

  const { data: queryData } = useOrganizationBaseDetailsQuery({
    variables: { id: organizationId },
    skip: !!cacheData,
  })

  const workspaceName = cacheData
    ? cacheData.name
    : queryData?.organizationDetails?.name

  return (
    <StandardSingleColumn>
      <Heading as="h1" css={headingCss} variant="EMPHASIZED">
        {text.headers.addSite}
        {workspaceName && (
          <React.Fragment>
            {" "}
            <FormattedMessage<"workspaceName", "span">
              message={text.messages.workspaceName}
              values={{
                workspaceName,
              }}
              tags={{
                span: function (content) {
                  return <span>{content}</span>
                },
              }}
            />
          </React.Fragment>
        )}
      </Heading>
      {subHeadingText && <Text size="S">{subHeadingText}</Text>}
    </StandardSingleColumn>
  )
}
